import type { FC, ReactNode } from 'react'
import type { LegalBlock } from '@/components/sections/legal'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { PageHero } from '@/components/sections/page-hero'
import { Legal } from '@/components/sections/legal'
import { Cta } from '@/components/sections/cta'

const blocks: LegalBlock[] = [
    {
        title: 'Information we collect',
        paragraphs: [
            'When you use the contact or free estimate forms on this website, we receive the details you choose to send us, such as your name, email address, phone number, the service you need, a preferred date and a description of your project.',
            'If you call us at 774-301-1382 or email ngpaintingpro1@gmail.com, we receive whatever you share with us there.',
            'Our hosting provider automatically records standard technical information, such as browser and device type and the pages viewed, to keep the site running and to give us overall visitor statistics.'
        ]
    },
    {
        title: 'How we use it',
        paragraphs: [
            'We use your information to answer your questions and prepare painting estimates, to schedule, carry out and follow up on work you hire us for, and to understand how visitors use this website so we can improve it.',
            'We do not sell, rent or trade your personal information.'
        ]
    },
    {
        title: 'Service providers',
        paragraphs: [
            'Our website host stores the messages sent through our forms and provides aggregated visitor statistics that are collected without cookies. We share your information with no one else except where the law requires it.'
        ]
    },
    {
        id: 'cookies',
        title: 'Cookies',
        paragraphs: [
            'This website does not use advertising cookies or tracking cookies, and our visitor statistics are collected without cookies.',
            'You can clear cookies and site data in your browser at any time. Doing so will not stop you from calling us or using our forms.'
        ]
    },
    {
        title: 'Data security and retention',
        paragraphs: [
            'We take reasonable measures to protect the information you send us. We keep it only as long as we need it to respond to you, complete your project, and meet our legal and accounting obligations.'
        ]
    },
    {
        title: 'Your choices',
        paragraphs: [
            'You can ask us to review, correct or delete your personal information at any time by emailing ngpaintingpro1@gmail.com or calling 774-301-1382.'
        ]
    },
    {
        title: 'Children',
        paragraphs: [
            'This website is not directed to children under 13, and we do not knowingly collect their information.'
        ]
    },
    {
        title: 'Changes to this policy',
        paragraphs: [
            'We may update this policy from time to time. The date at the top of this page shows the most recent revision.'
        ]
    },
    {
        title: 'Contact',
        paragraphs: [
            'NG Painting Pro, New Bedford, MA. Phone: 774-301-1382. Email: ngpaintingpro1@gmail.com.'
        ]
    }
]

const PrivacyPolicy: FC = (): ReactNode => {
    return (
        <Layout>
            <Seo
                title='Privacy policy'
                description='How NG Painting Pro collects, uses and protects the information you share through our website, by phone or by email, and how cookies are used.'
            />

            <PageHero
                title='Privacy Policy'
                subtitle='How we collect, use and protect the information you share with us.'
                subtitleModifier='legal'
            />

            <Legal updatedOn='November 3, 2026' blocks={blocks} />
            <Cta />
        </Layout>
    )
}

export default PrivacyPolicy
